export default __webpack_public_path__ + "static/background-b787c7fc5fa990adef84d0b0db9a307b.png";